import * as R from 'ramda';
import { useState } from 'react';
import { useModalState } from '../../../../../hooks/useModalState';
import { Action } from '../../../../MultipleActionsInterfaces';
import { UseMassActionsBarParams } from './useMassActionsBar.types';

const isActionActive = <T>(action: Action<T>) => (R.isNil(action.active) ? true : action.active);

export function useMassActionsBar<T>({
  actions,
  onClickAction,
  isAllSelected,
  totalSelected,
  toggleAllSelected,
  massActionFilter,
}: UseMassActionsBarParams<T>) {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const { isOpen: isMenuOpen, openModal: openMenu, closeModal: closeMenu } = useModalState();

  const shortcutActions = actions.filter((action) => action.showShortcut && isActionActive(action));
  const menuActions = actions.filter(
    (action) => action.isMassAction && action.label && isActionActive(action),
  );

  const isChecked = Boolean(isAllSelected || (massActionFilter?.enabled && massActionFilter.value));
  const isIndeterminate = !isChecked && totalSelected > 0;

  const handleToggleAllSelected = () => {
    if (massActionFilter?.enabled && massActionFilter.value) {
      massActionFilter.onToggle();
    } else {
      toggleAllSelected();
    }
  };

  const handleActionClick = (action: Action<T>) => {
    closeMenu();
    onClickAction(action);
  };

  return {
    isMenuOpen,
    anchorEl,
    setAnchorEl,
    shortcutActions,
    menuActions,
    hasMenu: menuActions.length > 0,
    isChecked,
    isIndeterminate,
    handleToggleAllSelected,
    handleActionClick,
    openMenu,
    closeMenu,
  };
}
